function singletonInstance() {
  if (this._instance) {
    return this._instance;
  }
  this._instance = this;
  return this;
}

export default singletonInstance;
